import { useState } from "react";
import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { WhyItWorks } from "../components/WhyItWorks";
import { BeforeAfter } from "../components/BeforeAfter";
import { Services } from "../components/Services";
import { Process } from "../components/Process";
import { FAQ } from "../components/FAQ";
import { FinalCTA } from "../components/FinalCTA";
import { Footer } from "../components/Footer";
import { BookingDialog } from "../components/BookingDialog";

export default function Landing() {
    const [bookingOpen, setBookingOpen] = useState(false);
    const openBooking = () => setBookingOpen(true);

    const scrollToExamples = () => {
        document
            .getElementById("examples")
            ?.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <main className="relative bg-white text-black min-h-screen overflow-x-hidden">
            <Nav />
            <Hero onPrimary={openBooking} onSecondary={scrollToExamples} />
            <WhyItWorks />
            <BeforeAfter />
            <Services onCta={openBooking} />
            <Process />
            <FAQ />
            <FinalCTA onCta={openBooking} />
            <Footer />
            <BookingDialog open={bookingOpen} onOpenChange={setBookingOpen} />
        </main>
    );
}
